import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { OrderStatus, ORDER_STATUS_COLORS } from '@/types/order';

interface OrderStatusBadgeProps {
  status: OrderStatus;
  className?: string;
}

const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({ status, className }) => {
  const { t } = useTranslation();

  return (
    <span
      className={classNames(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        ORDER_STATUS_COLORS[status],
        className
      )}
    >
      {t(`orders.status.${status}`)}
    </span>
  );
};

export default OrderStatusBadge;
